import { Component } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ModificationCommonService } from '../../services/modification-common.service';
import { IncomeProofBottomsheetComponent } from '../../components/income-proof-bottomsheet/income-proof-bottomsheet.component';

@Component({
  selector: 'app-try-again',
  imports: [],
  templateUrl: './try-again.component.html',
  styleUrl: './try-again.component.less'
})
export class TryAgainComponent {
  btnLoader = false;

  constructor(
      private _bottomSheet: MatBottomSheet,
      private modificationCommonService: ModificationCommonService,
  ) {}

  openBottomSheet(): void {
      this._bottomSheet.open(IncomeProofBottomsheetComponent);
  }

  submit(){
      this.modificationCommonService.getVendorURL()
  }
}
